/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { FACEBOOK_COLORS } from '@coursera-web/custom-colors';

import { InlineNotification, Typography2 } from '@coursera/cds-core';
import { SvgFacebook } from '@coursera/coursera-ui/svg';

import LinkButton from 'bundles/third-party-auth/components/AccountLink/LinkButton';
import { useAccountLink } from 'bundles/third-party-auth/components/AccountLink/hooks/useAccountLink';

import _t from 'i18n!nls/third-party-auth';

const styles = {
  row: css`
    display: flex;
    flex-direction: column;
  `,
  topRow: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--cds-spacing-150);
  `,
  label: css`
    display: flex;
    align-items: center;
    gap: var(--cds-spacing-150);
    margin: 0;
  `,
  liveRegion: css`
    min-height: 0;

    &:not(:empty) {
      margin-top: var(--cds-spacing-200);
    }
  `,
};

const AccountLinkFacebook = () => {
  const { isLinked, isDisabled, isLoading, errorMessage, successMessage, handleLink, handleDelink } = useAccountLink(
    'facebook',
    { grantSharePermissions: false }
  );

  return (
    <div css={styles.row} data-testid="account-link-facebook">
      <div css={styles.topRow}>
        <Typography2 variant="subtitleMedium" component="h3" css={styles.label}>
          <SvgFacebook size={20} color={FACEBOOK_COLORS.BLUE} aria-hidden />
          {_t('Facebook')}
        </Typography2>
        <LinkButton
          provider="facebook"
          linked={isLinked}
          disabled={isDisabled}
          loading={isLoading}
          onLink={handleLink}
          onDelink={() => handleDelink()}
        />
      </div>
      <div role="status" aria-live="polite" aria-atomic="true" css={styles.liveRegion}>
        {successMessage && <InlineNotification severity="success">{successMessage}</InlineNotification>}
      </div>
      <div role="alert" aria-live="assertive" aria-atomic="true" css={styles.liveRegion}>
        {errorMessage && <InlineNotification severity="error">{errorMessage}</InlineNotification>}
      </div>
    </div>
  );
};

export default AccountLinkFacebook;
